module.exports = __webpack_public_path__ + "static/media/mobileappdev.6c7ff8da.png";